'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _JacketViewButton = require('./components/JacketViewButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_JacketViewButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-jacket-view-button/lib/index.js
// module id = 1329
// module chunks = 1